import { AxiosRequestConfig } from 'axios'

let config: AxiosRequestConfig | null = null

let hzConfig: AxiosRequestConfig | null = null

const setAxiosConfig = (_config: AxiosRequestConfig) => {
  config = _config
}

const setHZAxiosConfig = (_config: AxiosRequestConfig) => {
  hzConfig = _config
}

const getAxiosConfig = () => {
  if (!config) {
    if (process.env.NODE_ENV === 'development') {
      console.error('You need to configure Axios before using it !')
      console.error('You need to configure Axios before using it !')
      console.error('You need to configure Axios before using it !')
    }
  } else {
    return config
  }
}

const getHZAxiosConfig = () => {
  if (!hzConfig) {
    if (process.env.NODE_ENV === 'development') {
      console.error('You need to configure HZ Axios before using it !')
      console.error('You need to configure HZ Axios before using it !')
      console.error('You need to configure HZ Axios before using it !')
    }
  } else {
    return hzConfig
  }
}

export { getAxiosConfig, setAxiosConfig, getHZAxiosConfig, setHZAxiosConfig }
